var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcentrationGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 32.2H18.8V38H24.6001V32.2Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 8.99994H18.8V14.7999H24.6001V8.99994Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7999 26.4001H12.9999V32.2001H18.7999V26.4001Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 26.4001H24.6V32.2001H30.4V26.4001Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7999 14.8H12.9999V20.6001H18.7999V14.8Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 20.5999H18.8V26.3999H24.6001V20.5999Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 14.8H24.6V20.6001H30.4V14.8Z",
    fill: "#5DEE7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2 0H7.20004C5.43286 0 4 1.43277 4 3.20004V43.8C4 45.5671 5.43277 47 7.20004 47H36.2001C37.9672 47 39.4001 45.5672 39.4001 43.8V3.20004C39.4 1.43277 37.9672 0 36.2 0ZM36.2 8.99995H30.4V14.8H36.2V20.6H30.4V26.4H36.2V32.2H30.4V38H36.2V43.8H30.4V38H24.6V43.8H18.8V38H12.9999V43.8H7.20004V38H12.9999L13 32.2H7.20004V26.4H13V20.6H7.20004V14.8H13V8.99995H7.20004V3.20004H13V8.99995L18.8 9.00004V3.20004H24.6V9.00004H30.4V3.20004H36.2001V8.99995H36.2Z",
    fill: "#5DEE7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38_189",
    x: 0,
    y: 0,
    width: 43.4001,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_189",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentrationGreen);
export default __webpack_public_path__ + "static/media/concentration-green.f38d3c8556e2f2afd77d897165ea0254.svg";
export { ForwardRef as ReactComponent };